import * as auth from './auth';
import * as upload from './upload';
import * as publications from './publications';
import * as lectures from './lectures';
import * as courses from './courses';
import * as stream from './stream';
import * as tags from './tags';
import * as country from './country';
import * as modules from './modules';
import * as referrals from './referrals';
import * as webinars from './webinars';
import * as purchases from './purchases';
import * as audience from './audience';
import * as push from './push';
import * as consultations from './consultations';
import * as meditations from './meditations';
import * as marathons from './marathons';
import * as qa from './qa';
import * as chat from './chat';
import * as quiz from './quiz';

const api = {
	// auth
	login: auth.login,
	logout: auth.logout,
	getUser: auth.getUser,
	updateUserData: auth.update,
	checkEmail: auth.checkEmail,
	checkRegistrationCode: auth.checkRegistrationCode,
	register: auth.register,
	forgotPassword: auth.forgotPassword,
	resetPassword: auth.resetPassword,
	ambassadorList: auth.ambassadorList,

	// upload
	createSession: upload.createSession,
	uploadSessionFile: upload.uploadSessionFile,
	closeSession: upload.closeSession,
	getSessionById: upload.getSessionById,
	uploadImage: upload.uploadImage,
	uploadRegisterImage: upload.uploadRegisterImage,
	uploadAttachmentModule: upload.uploadAttachmentModule,
	getAuthorPlan: upload.getAuthorPlan,
	getQuotaUsage: upload.getQuotaUsage,

	//publications
	publicationsList: publications.list,
	createPublication: publications.create,
	publicationById: publications.getById,
	editPublication: publications.edit,
	unpublishPublication: publications.unpublish,
	publishPublication: publications.publish,
	publicationRequestApproval: publications.requestApproval,
	deletePublication: publications.deletePublication,
	clearPublicationRejection: publications.clearRejection,
	archivePublication: publications.archive,
	canArchivePublication: publications.canArchive,

	// marathons
	createMarathon: marathons.create,
	marathonList: marathons.list,
	marathonById: marathons.getById,
	updateMarathon: marathons.update,
	cancelMarathon: marathons.cancel,

	// lecture
	createLecture: lectures.create,
	lecturesList: lectures.list,
	lectureById: lectures.getById,
	updateLecture: lectures.update,
	deleteLecture: lectures.deleteLecture,

	//meditations
	createMeditation: meditations.create,
	meditationsList: meditations.list,
	meditationById: meditations.getById,
	updateMeditation: meditations.update,

	// courses
	createCourse: courses.create,
	coursesList: courses.list,
	courseById: courses.getById,
	updateCourse: courses.update,

	// modules
	createCourseModule: modules.create,
	removeCourseModule: modules.remove,
	editCourseModule: modules.edit,
	removeAttachmentModule: modules.removeAttachment,
	createMarathonModule: modules.marathonCreate,
	removeMarathonModule: modules.marathonRemove,
	editMarathonModule: modules.marathonEdit,
	removeAttachmentModuleMarathon: modules.marathonRemoveAttachment,


	// streams
	getStreamById: stream.getStreamById,
	getStreamLinkById: stream.getStreamLinkById,
	getStreamAssetLinkById: stream.getStreamAssetLinkById,
	getStreamList: stream.getStreamList,

	// tags
	tagsList: tags.list,
	createTag: tags.create,

	// countries
	countryList: country.list,

	//referrals
	referralsList: referrals.list,
	referralActionsList: referrals.actionsList,

	// webinars
	webinarById: webinars.getById,
	webinarsList: webinars.list,
	createWebinar: webinars.create,
	editWebinar: webinars.edit,
	cancelWebinar: webinars.cancel,
	editWebinarPublication: webinars.editPublication,
	checkCanStartWebinar: webinars.checkCanStart,
	startWebinar: webinars.start,
	finishWebinar: webinars.finish,

	//purchases
	purchasesList: purchases.list,
	createAuthorPayment: purchases.createAuthorPayment,
	authorPaymentList: purchases.authorPaymentList,
	authorPaymentCheck: purchases.authorPaymentCheck,
	authorPaymentGet: purchases.authorPaymentGet,
	metricsSales: purchases.metricsSales,
	metricsRefunds: purchases.metricsRefunds,
	refundList: purchases.refundList,
	metricsPayouts: purchases.metricsPayouts,
	metricsProducts: purchases.metricsProducts,
	metricsPurchases: purchases.metricsPurchases,
	metricsLikes: purchases.metricsLikes,
	metricsProgressLectures: purchases.metricsProgressLectures,
	metricsProgressLecturesSummary: purchases.metricsProgressLecturesSummary,
	metricsProgressQuizzes: purchases.metricsProgressQuizzes,
	metricsProgressQuizzesSummary: purchases.metricsProgressQuizzesSummary,

	//audience
	audienceList: audience.list,

	// pushes
	createPush: push.create,

	// consultations
	consultationsList: consultations.list,
	consultationById: consultations.getById,
	createConsultation: consultations.create,
	editConsultation: consultations.edit,
	fulfillmentList: consultations.fulfillmentList,
	fulfillmentStatusUpdate: consultations.fulfillmentStatusUpdate,

	// qa (вопрос-ответ)
	createQA: qa.create,
	qaList: qa.list,
	qaById: qa.getById,
	updateQA: qa.update,
	removeQA: qa.remove,

	...quiz,

	// chat
	chatList: chat.getChatList,
	chatMessages: chat.getMessages,
	chatSend: chat.sendMessage,
	chatMarkRead: chat.markRead,
	chatBlock: chat.blockChat,
	chatUnblock: chat.unblockChat,
	chatHide: chat.hideChat,
	chatUnhide: chat.unhideChat,
	chatReportMessage: chat.reportMessage,
	chatUnreportMessage: chat.unreportMessage,
	chatHideMessage: chat.hideMessage,
	chatUnhideMessage: chat.unhideMessage,

};

export default api;
